import { compressSessionStorage } from '../../../../utils/sessionStorage';
import { formActionNaming } from '../../../../components/forms/ActionForms/constants';
import { newCreationDraftId } from './creationDraft';

/**
 * Siembra el borrador de la actuación NORMAL como «sin red»: la fase 1 no crea
 * nada y la fase 2 encolará la creación entera en la cola compound.
 *
 * Lo llaman dos caminos: la página, cuando el sondeo previo no llega al
 * servidor (como siempre), y ahora la propia fase 1 cuando su `SAVE_ACTION` se
 * aborta por el plazo o falla por transporte (spec 2026-09-08-fase2-encolada
 * § 2 D6). En ese segundo caso viaja `createClientOpId`, el del intento
 * abortado: el replay lo reutiliza y, si el create sí había llegado, el backend
 * devuelve la actuación ya creada en vez de duplicarla (D3).
 */
export function seedOfflineDraft(
  draft: Record<string, unknown>,
  extra: { createClientOpId?: string } = {},
): void {
  sessionStorage.setItem(
    formActionNaming.NEW_ACTION_DATA,
    compressSessionStorage(
      JSON.stringify({
        ...draft,
        // Sigue el borrador que empezó su puerta (`pass-data`): mismo
        // `draftId`. Uno de antes de este cambio recibe uno aquí (spec
        // 2026-11-02 wizard-draft-ownership § 6).
        draftId:
          typeof draft.draftId === 'string' && draft.draftId
            ? draft.draftId
            : newCreationDraftId(),
        _isOffline: true,
        ...(extra.createClientOpId ? { createClientOpId: extra.createClientOpId } : {}),
      }),
    ),
  );
}
